module.exports = __webpack_public_path__ + "img/work-slide-03-small.e88cd0cd.jpg";